/**
 * Application constants for NewsDesk
 * Contains playback modes, time formats, and utility functions
 *
 */

const playbackModes = [
  { value: 'normal', label: 'Normal' },
  { value: 'stop', label: 'Stop' },
  { value: 'holdLastFrame', label: 'Hold' },
  { value: 'loop', label: 'Loop' }
]

const getPlaybackModeLabel = (value) => {
  const mode = playbackModes.find((mode) => mode.value === value)
  return mode?.label
}

// Sentinel shown in UI to represent a stored password field (never sent back to the server as-is).
export const PASSWORD_SENTINEL = '••••••••'

// AG-Grid's server-side row model derives each group node's key from the grouped value the
// server returns, and a null/empty value produces a group node that renders (e.g. the "TBD"
// story_date group) but silently never requests its children on expand -- no error, no network
// call. StoriesGrid.vue substitutes this sentinel for null/empty grouped values in the
// datasource response so the group can expand, then translates it back to a null filter when
// the group is expanded; GroupRowInnerRenderer.vue maps it back to the empty-group label.
export const EMPTY_GROUP_KEY = '__EMPTY_GROUP__'

// Connection types supported by the platform connection system.
// Mirrors PlatformConnection::CONNECTION_TYPES on the backend — update both when adding a new type.
export const CONNECTION_TYPES = [
  'content_delivery',
  'asset_delivery',
  'live_status',
  'live_editing',
  'playback_control',
  'video_preview',
  'routing_control',
  'graphics'
]

// Read from VITE_EDITOR_SCHEMA_VERSION in .env (base file, all environments).
// Increment when a new TipTap node/mark type is added to the schema.
// The API refuses editors below its EDITOR_SCHEMA_VERSION setting, so raise that only once
// the build carrying this value is deployed.
// Version history: 1=basic text  2=production notes  3=nd-* production elements  4=strike and link on mobile
export const EDITOR_SCHEMA_VERSION = Number(import.meta.env.VITE_EDITOR_SCHEMA_VERSION)

export const constants = {
  playbackModes,
  getPlaybackModeLabel,
  timeFormats: ['h:mm a', 'h:mm A', 'HH:mm', 'H:mm', 'h:mma', 'h:mmA', 'HHmm']
}
